import compareObjects from "./compareObjects";

export default function compareArrays(
  arrayOne: any[],
  arrayTwo: any[]
): boolean {
  if (arrayOne.length !== arrayTwo.length) {
    return false;
  }

  for (let i = 0; i < arrayOne.length; i++) {
    const valueOne = arrayOne[i];
    const valueTwo = arrayTwo[i];

    if (typeof valueOne === "object" && typeof valueTwo === "object") {
      if (Array.isArray(valueOne) && Array.isArray(valueTwo)) {
        if (!compareArrays(valueOne, valueTwo)) {
          return false;
        }
      } else {
        if (!compareObjects(valueOne, valueTwo)) {
          return false;
        }
      }
    } else {
      if (valueOne !== valueTwo) {
        return false;
      }
    }
  }

  return true;
}
